export default __webpack_public_path__ + "static/media/iphone-mockup.09abf959.png";